// Portal-style layout: header row with title on the left, compact labeled
// selects (App Group / Release) + Reload on the right, then the standard
// portal table.
const styles = {
  mainBox: {
    mx: "5px",
    pt: "16px",
    pb: "12px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  },
  headerGrid: {
    alignItems: "flex-end",
    flexShrink: 0,
  },
  controlsStack: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    gap: "8px",
    mb: "16px",
  },
  selectLabel: (colors) => ({
    fontSize: "10.5px",
    color: colors.grey[300],
    mb: "3px",
  }),
  select: (colors) => ({
    height: "32px",
    minWidth: "170px",
    fontSize: "13px",
    color: colors.grey[700],
    backgroundColor: colors.primary[700],
    borderRadius: "6px",
    "& .MuiSelect-select": {
      py: 0,
      display: "flex",
      alignItems: "center",
    },
  }),
  // Same height as the selects so the row bottom-aligns cleanly.
  reloadButton: {
    m: "0px 0 0 2px",
    width: "fit-content",
    minHeight: "32px",
  },
  // Portal `btnBrand`: white surface, brand border/text, compact height.
  reportButton: (colors) => ({
    backgroundColor: colors.primary[700],
    borderColor: colors.blue[500],
    color: colors.blue[700],
    minHeight: "26px",
    padding: "0 10px",
    fontSize: "12.5px",
    fontWeight: 500,
    "&:hover": {
      backgroundColor: colors.blue[100],
      borderColor: colors.blue[500],
    },
  }),
  coverageCell: (colors, isZero) => ({
    fontSize: 13,
    color: isZero ? colors.grey[300] : colors.grey[700],
  }),
  dataTable: { flex: 1, minHeight: 0 },
};
export default styles;
